import React from 'react';
import { DateRangePicker, defaultStaticRanges } from 'react-date-range';
//import tr from 'date-fns/locale/tr';
//import en from 'date-fns/locale/en-GB';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
//const dateLocales = { tr, en };
defaultStaticRanges.shift();
defaultStaticRanges.shift();

const Picker = (props) => (
	// eslint-disable-next-line react/react-in-jsx-scope
	<DateRangePicker
		ranges={[
			{
				startDate: props.startDate,
				endDate: props.endDate,
				key: 'selection',
			},
		]}
		maxDate={new Date()}
		onChange={props.dateChange}
		staticRanges={defaultStaticRanges}
		inputRanges={[]}
	/>
);

export default Picker;
